import { render, staticRenderFns } from "./Questions.vue?vue&type=template&id=7dbaca34&scoped=true"
import script from "./Questions.vue?vue&type=script&lang=js"
export * from "./Questions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbaca34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dbaca34')) {
      api.createRecord('7dbaca34', component.options)
    } else {
      api.reload('7dbaca34', component.options)
    }
    module.hot.accept("./Questions.vue?vue&type=template&id=7dbaca34&scoped=true", function () {
      api.rerender('7dbaca34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/teacher/vue/slides/Questions.vue"
export default component.exports